// app/javascript/controllers/segmented_controller.js
// Single-choice segmented control writing into a hidden input. Re-clicking the
// active option clears it (the field is optional → empty value).
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "input"]

  select(event) {
    const option = event.currentTarget
    const wasActive = option.classList.contains("is-active")

    this.optionTargets.forEach((other) => {
      other.classList.remove("is-active")
      other.setAttribute("aria-pressed", "false")
    })

    if (wasActive) {
      this.inputTarget.value = ""
    } else {
      option.classList.add("is-active")
      option.setAttribute("aria-pressed", "true")
      this.inputTarget.value = option.dataset.value
    }
  }
}
